const data = [
  { id: 1, name: 'Sim' },
  { id: 2, name: 'Não' },
  { id: 3, name: 'Nulo' },
]

export default [...data]
